import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-77ec4aec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "消息", -1));
const _hoisted_3 = {
  key: 0,
  class: "megCount"
};
const _hoisted_4 = {
  class: "hidden-over"
};
import { setStorage } from '@/utils/storage';
// import { incrementPageCount } from '@/utils/visit';
import api from '@/api/api';
import emitter from '@/utils/eventBus';


import { ref, onMounted, onUnmounted } from 'vue';
// 用户信息

export default {
  __name: 'index',
  setup(__props) {
    const userInfo = ref({});
    //信息数据统计
    const count = ref(0);
    // 数据初始化
    onMounted(() => {
      getUserInfo();
      getMessageCount();
    });
    // 获取用户信息
    const getUserInfo = () => {
      api.getCurrentUseInfo().then(res => {
        if (res.data.code === 200) {
          userInfo.value = res.data.user;
          setStorage('currentUserInfo', res.data.user);
        }
      });
    };
    //获取信息数据
    const getMessageCount = async () => {
      const res = await api.getMessageTopCount();
      if (res.data.code == 200) {
        count.value = res.data.data.filter(val => val.messageType == 0)[0]?.count;
      }
    };
    // 跳转用户页
    const handleToPersonCenter = () => {
      setStorage('title', '个人中心');
      // router.push('/person');
      //记录页面数量
      // incrementPageCount();
      window.open('#/person', '_blank');
    };
    const handleToPerson = () => {
      setStorage('title', '个人中心');
      setStorage('currentTabIndex', 1);
      // router.push('/person');
      //记录页面数量
      // incrementPageCount();
      window.open('#/person', '_blank');
    };
    //事件总线监听  在个人中心我的消息中发出 刷新已读状态
    emitter.on('topRead', () => {
      getMessageCount();
    });
    //销毁事件总线监听
    onUnmounted(() => {
      emitter.off('topRead');
    });
    return (_ctx, _cache) => {
      const _component_BellFilled = _resolveComponent("BellFilled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_WarningFilled = _resolveComponent("WarningFilled");
      const _component_Avatar = _resolveComponent("Avatar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "message",
        onClick: handleToPerson
      }, [_createVNode(_component_el_icon, {
        size: "14"
      }, {
        default: _withCtx(() => [_createVNode(_component_BellFilled)]),
        _: 1
      }), _hoisted_2, _unref(count) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_WarningFilled)]),
        _: 1
      })])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: "login-box",
        onClick: handleToPersonCenter
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Avatar)]),
        _: 1
      }), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(userInfo).nickName), 1)])]);
    };
  }
};